import { attachment } from '../attachment/attachment.model';
import { Contact } from './contact.model';

export class BatchText {
  body: string;
  senderName: string;
  members: number[];
  scheduleTime: Date;
  attachments: attachment[] = [];  
}

export class DirectBatchText {
  body: string;
  senderName: string;
  contacts: Contact[];
  scheduleTime: Date;
  attachments: attachment[] = [];  
}
 